<template>
    
    <div id="app">
        
        <transition 
            v-if="isLoaded"
            mode="out-in"
            v-on:appear="appear"
            v-on:leave="leave"
            v-on:before-enter="beforeEnter"
            v-on:enter="enter"
            v-bind:css="false"
        >
            <router-view @loaded="onPageReady"></router-view>
        </transition>

        <Navigation v-if="isLoaded" />
        
        <Grafitti ref="grafitti" />
        
        <Preloader @loaded="onLoaded" />
    </div>
    
</template>


<script>
import Vue from 'vue'
import { TweenLite, CSSPlugin, ScrollToPlugin } from "gsap/all";
import Navigation from '@/components/Navigation'
import Preloader from '@/components/Preloader'
import Grafitti from '@/components/Grafitti'

export default {
    
    components: {
        Navigation,
        Preloader,
        Grafitti,
    },
    
    data: function() {
        return {
            isLoaded: false
        }  
    },
    
    created() {
        // Make sure Vue loader includes GSAP, otherwise removed from prod build == ALL GSAP Animations fails
        const a = CSSPlugin // eslint-disable-line
        const b = ScrollToPlugin // eslint-disable-line
    },
    
    mounted() {},
    
    destroyed() {},
    
    methods: {
        onLoaded() {
            this.isLoaded = true
        },
        
        appear(node) {
            // onLoad / mounted
            TweenLite.set(node, {opacity: 0})
            TweenLite.to(node, 0.6, {opacity: 1})
        },
        
        onPageReady() {
            // Scroll to correct position after Axios loaded JSON - https://forum.vuejs.org/t/cant-get-scrollbehavior-working/29077/6
            this.$root.$emit('scrollToPosition');
            
            Vue.nextTick(() => {
                this.$refs.grafitti.onResize()
            })
            
        },
        
        // Chain animation: leave, beforeEnter, enter 
        leave(node, done) {
            TweenLite.to(node, 0.4, {opacity: 0, onComplete: done})
        },
        
        beforeEnter(node) {
            node.style.opacity = 0
        },
        
        enter(node, done) {
            TweenLite.to(node, 0.6, {opacity: 1, onComplete: done })
        },
    },
}
</script>

<style lang="scss">


@import '@/scss/variables',
        '@/scss/reset',
        '@/scss/typography',
        '@/scss/font-scaling';


.loader {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: red;
    
    .loader-text {
        
    }
}
</style>
